import { Injectable } from "@angular/core";
import { Course } from "@app/affiliates/models/model";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SearchService {

  public ClickedCourse: Course;
  
  // Reactividad para los cursos devueltos por las busquedas
  public searchedCourses$ = new BehaviorSubject<Course[]>([]);
  public _searchedCourses$ = this.searchedCourses$.asObservable();

  /*  Reactividad para mantener "una unica fuente" de la verdad en cuanto al estado de las busquedas; 
      Acá se setea los nuevos cursos con su correspondiente last_item
  */
  private _coursesState = new BehaviorSubject<{courses: any[];last_item: any;}>({courses: [],last_item: null,});
  coursesState$ = this._coursesState.asObservable();

  // Este behavior permite comportarse de listener para saber cuando se está buscando
  loadingCourses$ = new BehaviorSubject<boolean>(false);
  _loadingCourses$ = this.loadingCourses$.asObservable();

  setCoursesState(courses: any[], last_item: any) {
    this._coursesState.next({ courses, last_item });
    this.searchedCourses$.next(courses);
    this.LEKCourses = last_item;
  }

  // GET que permite obtener el estado del stream del courses_state
  get currentState() {
    return this._coursesState.getValue();
  }

  public LEKCourses: any;

  constructor() {}

  // Esta función permite priorizar el curso que fue clickeado en el suggestion del navBar
  prioritizeClickedCourse() {
    if (!this.ClickedCourse) return;
    const courses = this.searchedCourses$.getValue();
    const index = courses.findIndex((c) => c.id == this.ClickedCourse.id);
    if (index == -1) return;
    const [clickedCourse] = courses.splice(index, 1);
    courses.unshift(clickedCourse);
    this.searchedCourses$.next(courses);
  }

  default() {
    this.ClickedCourse = null;
    this.searchedCourses$.next([]);
    this.loadingCourses$.next(false);
  }
}
